import { render, staticRenderFns } from "./ChatBase.vue?vue&type=template&id=1714644c&scoped=true&"
import script from "./ChatBase.vue?vue&type=script&lang=js&"
export * from "./ChatBase.vue?vue&type=script&lang=js&"
import style0 from "./ChatBase.vue?vue&type=style&index=0&id=1714644c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1714644c",
  null
  
)

export default component.exports